/**
 * groupCode 分组代码
 * code 单个代码
 * codes 多个代码
 * textCode 富文本
 * xxx 自定义
 */

/**
 * 页面配置
 */
export const AdConfig = {
  Notice: {
    code: 'it_gxyx_pmd',
  },
  Rule: {
    code: 'it_gxyx_hdgz',
  },
  Banner: {
    code: 'g_gxyx_banner',
  },
};

/**
 * 分享配置
 */
export const shareAdConfig = {
  common: {
    //普通分享
    code: 'it_welfare_officer_share', // 大赛配置后台，首页分享
  },
  Etf: {
    //高校邀新_ETF模拟赛
    code: 'g_gxyx_etf',
  },
  Game: {
    //高校邀新-金融挑战赛
    code: 'g_gxyx_jrtzs',
  },
  Konwledge: {
    //高校邀新-知识比拼
    code: 'g_gxyx_zsbp',
  },
};

/**
 * 上下滚动跑马灯配置
 */
export const scrollData = [
  '恭喜Z***睡 获得金龙转运珠',
  '恭喜宽***昆 获得金龙转运珠',
  '恭喜基***A 获得金龙转运珠',
  '恭喜鲲***美 获得金龙转运珠',
  '恭喜徐***彪 获得金龙转运珠',
  '恭喜q***7 获得金龙转运珠',
  '恭喜谁***0 获得金龙转运珠',
  '恭喜我***钱 获得金龙转运珠',
  '恭喜股***9 获得金龙转运珠',
  '恭喜股***帅 获得金龙转运珠',
  '恭喜炒***校 获得金龙转运珠',
  '恭喜股***3 获得金龙转运珠',
  '恭喜能***能 获得500元京东卡',
  '恭喜有***我 获得50元京东卡',
  '恭喜四***6 获得50元京东卡',
  '恭喜谁***0 获得300元京东卡',
  '恭喜基***A 获得200元京东卡',
  '恭喜炒***校 获得100元京东卡',
  '恭喜f***f 获得100元京东卡',
  '恭喜有***1 获得50元京东卡',
  '恭喜股***A 获得100元京东卡',
  '恭喜鲲***美 成功提现500元',
  '恭喜基***A 成功提现405.36元',
  '恭喜股***A 成功提现351.08元',
  '恭喜时***转 成功提现326.44元',
  '恭喜雾***一 成功提现303.64元',
  '恭喜f***f 成功提现200元',
  '恭喜谁***0 成功提现200元',
  '恭喜有***1 成功提现200元',
  '恭喜股***3 成功提现200元',
  '恭喜孤***天 成功提现184.96元',
  '恭喜呜***我 成功提现155.84元',
  '恭喜有***我 成功提现151.88元',
  '恭喜四***6 成功提现147.88元',
  '恭喜徐***彪 成功提现144.68元',
  '恭喜炒***校 成功提现137.80元',
  '恭喜四***6 成功提现129.8元',
  '恭喜有***1 成功提现128.08元',
  '恭喜股***3 成功提现123.32元',
  '恭喜永***1 成功提现117.92元',
  '恭喜大***锤 成功提现74.16元',
  '恭喜基***A 成功提现67.8元',
];
